export const getAction = (type) => {
  switch (type) {
    case "singForMe":
      return "Sing this song for me";
    case "singWithYou":
      return "I would like to sing this song with you";
    case "singAlone":
      return "I would like to sing this song solo";
    default:
      return "";
  }
};
